module.exports = __webpack_public_path__ + "static/img/238_TO8_2000_og.33bd39c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/238_TO8_2000_og.jpg
// module id = fYEC
// module chunks = 0